import React from 'react';
import './order-confirmation-summary.scss';
import CartItemSummary from '../cart-item-summary/cart-item-summary';
import CardImage from '../../../../components/card-image/card-image';
import { cashSupportEmail } from '../../../../utilities/cash-utilities';

/**
 * An order summary component containing cart item summaries
 * @param cashOrderCartItems The key/value pair object containing cart items
 * @param orderNumber Order number
 * @param addAmpolCash onClick event for Add AmpolCash option
 * @returns JSX Element
 */

const OrderConfirmationSummary = ({ cashOrderCartItems, orderNumber, accountNumber }) => {
  // todo: add email address to subheading
  return <>
    <div className='order-confirmation'>
      <div className='order-confirmation__header'>
        {orderNumber && <strong className='order-confirmation__order-heading'>Order #{orderNumber}.</strong>}
        <div className='order-confirmation__account-heading'>Order will be invoiced to account {accountNumber}.</div>
        <div className='order-confirmation__subheading'>If you have any questions about your order, please don&apos;t hesitate to email us at <a href={`mailto:${cashSupportEmail()}`}>{cashSupportEmail()}</a>.</div>
      </div>
      <div className='order-confirmation__cart-items'>
        <div className="order-confirmation__card-summary-heading">
          <div>Quantity</div>
          <div>Total</div>
        </div>
        {Object.entries(cashOrderCartItems).map(([key, cartItem]) => ( <React.Fragment key={key}>
          <div className='order-confirmation__image'>
            <CardImage
              isLarge={true}
              isDigital={cartItem.mediaType === 'D'}
              imageSource={cartItem.plasticTypeSource}
              useCacheImage={true}
            />
          </div>
          <div className='order-confirmation__content'>
            <CartItemSummary
              cartItem={cartItem}
              inlineView={true}
              showDelivery={true}/>
          </div>

          <div className="order-confirmation__card-summary-content">
            <div className='order-confirmation__quantity'>
              <div>Quantity:&nbsp;</div> {cartItem.quantity}
            </div>
            <div className='order-confirmation__total'>
              <div>Total:&nbsp;</div> ${cartItem.total}
            </div>
          </div>
        </React.Fragment> ))}
      </div>
    </div>
  </>;

};

export default OrderConfirmationSummary;
